import { createAction, handleActions, combineActions } from 'redux-actions';
import { fromJS, Map, List } from 'immutable';
import { createSelector } from 'reselect';
import { normalize, schema } from 'normalizr';

// Schemas
const clientEntity = new schema.Entity('clients')

// Actions
export const fetchClients = createAction('CLIENTS_FETCH')
export const fetchClientsSuccess = createAction('CLIENTS_FETCH_SUCCESS')
export const fetchClientsFail = createAction('CLIENTS_FETCH_FAIL')

export const fetchClient = createAction('CLIENT_FETCH')
export const fetchClientSuccess = createAction('CLIENT_FETCH_SUCCESS')
export const fetchClientFail = createAction('CLIENT_FETCH_FAIL')

export const createClient = createAction('CLIENT_CREATE')
export const createClientFail = createAction('CLIENT_CREATE_FAIL')

export const updateClient = createAction('CLIENT_UPDATE')
export const updateClientFail = createAction('CLIENT_UPDATE_FAIL')

export const deleteClient = createAction('CLIENT_DELETE')
export const deleteClientSuccess = createAction('CLIENT_DELETE_SUCCESS')
export const deleteClientFail = createAction('CLIENT_DELETE_FAIL')

export const actions = {
  fetchClients,
  fetchClientsSuccess,
  fetchClientsFail,
  fetchClient,
  fetchClientSuccess,
  fetchClientFail,
  createClient,
  createClientFail,
  updateClient,
  updateClientFail,
  deleteClient,
  deleteClientSuccess,
  deleteClientFail,
}

const defaultState = fromJS({
  result: List([]),
  data: {},
  isFetching: true,
  error: {}
})

export default handleActions({
  [fetchClients]: (state, action) => {
    return state.merge({
      isFetching: true,
    })
  },

  [fetchClientsSuccess]: (state, action) => {
    const normalizedData = normalize(action.payload, [clientEntity])
    return state.merge({
      result: normalizedData.result,
      data: normalizedData.entities.clients || {},
      isFetching: false
    })
  },

  [fetchClientSuccess]: (state, action) => {
    const normalizedData = normalize(action.payload, clientEntity)
    return state.merge({
      result: [],
      data: normalizedData.entities.clients,
      isFetching: false
    })
  },

  [deleteClientSuccess]: (state, action) => {
    const { id } = action.payload;
    const result = state.get('result');
    const data = state.get('data');

    return state.merge({
      result: result.delete(result.indexOf(id)),
      data: data.delete(id),
    });
  },

  [combineActions(
    fetchClientsFail,
    fetchClientFail,
    createClientFail,
    updateClientFail,
  )]: (state, action) => {
    return state.merge({
      error: action.payload,
      isFetching: false
    })
  }
}, defaultState)

// selectors
const resultSelector = state => state.client.data.get('result');
const clientsSelector = state => state.client.data.get('data');
const isFetchingSelector = state => state.client.data.get('isFetching');
const paginationSelector = state => state.client.pagination;

export const getClients = createSelector(
  resultSelector,
  clientsSelector,
  (result, clients) => result.map(id => clients.get(String(id))).toJS(),
);

export const getClient = (state, id) =>
  (clientsSelector(state).get(String(id)) || new Map()).toJS()

export const isFetching = createSelector(
  isFetchingSelector,
  isFetching => isFetching
)

export const getClientsPagination = createSelector(
  paginationSelector,
  paginationData => paginationData.toJS(),
);



// WEBPACK FOOTER //
// ./src/store/clientReducer.js